import React from 'react';
import { LogoutOutlined } from '@ant-design/icons';
import { logoutApi } from '@service';
import { Modal } from 'antd';

export default () => {

  const logout = () =>
    Modal.confirm({
      title: '退出登录?',
      onOk: async () => {
        const { flag } = await logoutApi({});

        flag === 200 && (window.location.href = '/login');
      },
      onCancel() {},
    });

  return (
    <span className="ml-12" onClick={logout}>
      <LogoutOutlined />
      退出登录
    </span>
  );
};
